import { Button, Group, Paper, Stack, Text, Title } from "@mantine/core";
import FilterContent from "../../../../../components/Filter/FilterContent";
import { useLeadsStore } from "../../../../../stores/LeadsStore";
import BackButton from "../../../../../components/View/BackButton";
import { Box } from "@mui/material";
import { IconArrowRight } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";

const NurturingFilters = ({
  filter,
  setFilter,
  setActiveStep,
  handleClose,
}) => {
  const lang = useLanguage((s) => s.language);
  const fields = useLeadsStore((s) => s.filters);

  const onFilterChange = (f) => {
    setFilter(f);
    setActiveStep("contacts");
  };

  return (
    <Paper component={Stack} withBorder p={"lg"} gap={"sm"}>
      <Title order={4}>{lang.prm.nurturing.step1.title}</Title>
      <Text>{lang.prm.nurturing.step1.text}</Text>

      <Box
        sx={{
          "& #filter-apply-button": {
            display: "none",
          },
        }}
      >
        <FilterContent
          fields={fields}
          id={"nurturing-filter"}
          isClient={false}
          pageName={"prm"}
          maxHeight={350}
          mainFilter={filter}
          setMainFilter={onFilterChange}
          defaultFiltersClose
          savedFiltersReadonly
          getFieldOptionName={(f) => f.option_name}
        />
      </Box>

      <Group mt={"md"} gap={"lg"}>
        <BackButton label={lang.global.close} onClick={handleClose} size="md" />

        <Button
          onClick={() => document.getElementById("filter-apply-button").click()}
          size="md"
          rightSection={<IconArrowRight />}
        >
          {lang.global.next}
        </Button>
      </Group>
    </Paper>
  );
};

export default NurturingFilters;
